import React, { useState, useRef } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import TermsModal from "./TermsModal";


function LeadCaptureModal({ showModal, setShowModal }) {
  const [loading, setLoading] = useState(false);
   const [openTermsModal, setOpenTermsModal] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const formRef = useRef();
  const navigate = useNavigate(); // <-- ADD THIS

  // Timeout wrapper to prevent infinite loading
  const fetchWithTimeout = (url, options = {}, timeout = 15000) => {
    return Promise.race([
      fetch(url, options),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error("timeout")), timeout)
      ),
    ]);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    const data = {
      first_name: formData.get("first_name").trim(),
      last_name: formData.get("last_name").trim(),
      email: formData.get("email").trim(),
      phone: formData.get("phone").trim(),
      company: formData.get("company").trim(),
      referred_by: formData.get("referred_by").trim(),
    };

    // Validation
    if (
      !data.first_name ||
      !data.last_name ||
      !data.email ||
      !data.phone ||
      !data.company 
    ) {
      Swal.fire("Warning", "Please fill out required information.", "warning");
      return;
    }

    if (!agreeTerms) {
      Swal.fire("Warning", "You must agree to the terms first.", "warning");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      Swal.fire("Error", "Please enter a valid email.", "error");
      return;
    }

    if (data.phone.length < 7) {
      Swal.fire("Error", "Please enter a valid phone number.", "error");
      return;
    }

    setLoading(true);

    try {
      // CRM Request
      const crmResponse = await fetchWithTimeout(
        "https://crm.weltriocare.com/api/create/tiptaxcolorado/lead",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      let crmResult;
      try {
        crmResult = await crmResponse.json();
      } catch {
        crmResult = { message: "Invalid CRM response" };
      }

      // Email Request
      const emailResponse = await fetchWithTimeout(
        "https://venturerev.com/api/send-email-tiptaxcolorado",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      let emailResult;
      try {
        emailResult = await emailResponse.json();
      } catch {
        emailResult = { success: false, message: "Invalid email response" };
      }

      // Success if BOTH API calls succeeded
      if (crmResponse.ok && emailResponse.ok && emailResult.success) {
        Swal.fire("Success", "Form submitted successfully!", "success");

        formRef.current.reset();
        setAgreeTerms(false);
        setShowModal(false);

        // 🔥 REDIRECT AFTER SUCCESS

        window.location.href = "https://app.tipcreditpartners.com/register-client/236a?c=3ef54b9f"
       

        return;
      }

      Swal.fire(
        "Error",
        crmResult.message ||
          emailResult.message ||
          "Something went wrong while submitting.",
        "error"
      );
    } catch (error) {
      console.error("Network Error:", error);
      Swal.fire("Error", "Network Error — Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`modal fade ${showModal ? "show d-block" : "d-none"}`}
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <TermsModal open={openTermsModal} setOpen={setOpenTermsModal} />
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 shadow">
          <div
            className="modal-header"
            style={{
              background: "linear-gradient(to right, #5f5f6bff, #3eb0e8)",
              color: "#fff",
            }}
          >
            <h5 className="modal-title text-center" style={{ width: "95%" }}>
              Start Application
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={() => setShowModal(false)}
            ></button>
          </div>

          <div className="modal-body">
            <form ref={formRef} onSubmit={handleFormSubmit} className="row g-3">
              {/*FIELDS ORIGINAL — NOT CHANGED*/}
              <div className="col-md-6">
                <label className="form-label">First Name</label>
                <input
                  type="text"
                  name="first_name"
                  className="form-control"
                  placeholder="Enter your first name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  className="form-control"
                  placeholder="Enter your last name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  placeholder="Enter your phone number"
                />
              </div>
<div className=""></div>
              <div className="col-md-6">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  name="company"
                  className="form-control"
                  placeholder="Enter company name"
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Referred by:</label>
                <input
                  type="text"
                  name="referred_by"
                  className="form-control"
                  placeholder=""
                />
              </div>

              <div className="col-md-12">
                <div className="checkbox-group" style={{ marginTop: "1rem" }}>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <input
                      type="checkbox"
                      id="agreeTerms"
                      name="agreeTerms"
                      checked={agreeTerms}
                      onChange={(e) => setAgreeTerms(e.target.checked)}
                      style={{
                        width: "1.2rem",
                        height: "1.2rem",
                        marginTop: "0.2rem",
                      }}
                    />
                    <label
                      htmlFor="agreeTerms"
                      style={{ fontSize: "0.9rem", lineHeight: "1.4rem" }}
                    >
                      I agree to  <span
                        onClick={() => setOpenTermsModal(true)}
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textDecoration: "underlined",
                        }}
                      >
                        terms & conditions
                      </span> and consent to receive
                      communications from Tiptax & TipTaxColorado such as SMS, WhatsApp messages,
                      or emails.
                    </label>
                  </div>
                </div>
              </div>

              <div className="text-center mt-3">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary px-5"
                  style={{ backgroundColor: "#3eb0e8" }}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeadCaptureModal;
